import { useEffect, useState } from 'react';
import { useFrontChatBoot } from 'front-chat-sdk/hooks';
import FrontChatToggle from './PageFrontChatToggle';
import { getRequest } from 'utils/request';

const chatId = 'b3f44a3c2d253972b805cf792de37f68';

interface Props {
  className?: string;
}

const PageFrontChat = (props: Props) => {
  const { className } = props;

  const [element, setElement] = useState<HTMLElement>();

  const { frontChat, isInitialized, initialize } = useFrontChatBoot(element);

  const [userChatHashData, setUserChatHashData] = useState<{
    chatHash: string;
    email: string;
  }>();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setElement(document.body);
    }
  }, []);

  useEffect(() => {
    if (!userChatHashData) {
      getRequest('/users/chat-hash')
        .then(response => {
          setUserChatHashData(response.data);
        })
        .catch(err => console.error('Failed to fetch chat hash:', err));
    }
  }, [userChatHashData]);

  useEffect(() => {
    if (!initialize || isInitialized) {
      return;
    }

    initialize({
      chatId,
      useDefaultLauncher: false,
      ...(userChatHashData?.email &&
        userChatHashData?.chatHash && {
          userHash: userChatHashData.chatHash,
          email: userChatHashData.email,
          userId: userChatHashData.email,
          name: userChatHashData.email,
        }),
    });
  }, [isInitialized, initialize, userChatHashData]);

  return (
    <FrontChatToggle
      frontChat={frontChat}
      isInitialized={isInitialized}
      className={className}
    />
  );
};

export default PageFrontChat;
